<ldk-navigation-bar
  #navbar
  [user]="user"
  [title]="title"
  [envName]="envName"
  [sideMenuSettings]="sideMenuSettings"
  (menuItemClicked)="menuItemClicked($event)">
</ldk-navigation-bar>